export const TAX_AMOUNT = 4800;
export const YEAR = 2026;
export const WORKFORCE_COMPANY_DAILY_WAGE = 15000;
export const PANNON_BUSZRENT_DAILY_WAGE = 22300;
export const MINIMUM_WAGE_MONTHLY = 322800;
export const MINIMUM_WAGE_WEEKLY = 74210;
export const MINIMUM_WAGE_DAILY = 14850;
export const MINIMUM_WAGE_HOURLY = 1856;
export const GUARANTEED_WAGE_MONTHLY = 373200;
export const GUARANTEED_WAGE_WEEKLY = 85800;
export const GUARANTEED_WAGE_DAILY = 17160;
export const GUARANTEED_WAGE_HOURLY = 2145;
export const TEMPORARY_WORK_WAGE = 1000;
